import { useQuery } from "@tanstack/react-query"
import { classes } from  '@shared/api/services'

export const useTeacher = (slug) => {
	return useQuery({
			queryKey: ['teacher', slug],
			queryFn: async () => {
					const teacherResponse = await classes.getTeacher(slug);
					let reviewsResponse
					if(process.env.REACT_APP_REVIEWS_FROM_SERVER){
						reviewsResponse = await classes.getLandingReviews(slug);
						teacherResponse.data.reviews = reviewsResponse.data;
					}else{
						reviewsResponse = await classes.getReviews(slug);
						teacherResponse.data.reviews = reviewsResponse.data.data;
					}
					return teacherResponse.data;
			},
			enabled: !!slug,
			select: (data) => data,
	})
}